var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-tags-wrapper"},[_c('Tags',{attrs:{"field":"publisher"}}),_c('Tags',{attrs:{"field":"include"}}),_c('Tags',{attrs:{"field":"country"}}),_c('Tags',{attrs:{"field":"language"}}),_c('Tags',{attrs:{"field":"year"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }